<!--대학/지부/분회 팝업 -->
<template>
    <modal v-if="isModalShow">
        <template slot="header">
          <h4 class="modal-title">지부/분회 조회</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closed">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <template slot="body">
          <div class="md-layout">
            <table class="flex-table">
              <tr>
                <th class="letter-dense">지부/분회명</th>
                <td>
                  <div class="inline-flex">
                    <input v-focus type="text" v-model="searchText" v-on:keyup.enter="search">
                    <button @click="search">
                      <md-icon>search</md-icon>조회
                    </button>
                  </div>
                </td>
              </tr>
            </table>
          </div>
<!--

          <div class="md-layout scroll-container">
            <md-table :value="list" class="paginated-table table-striped table-hover text-align-center">
              <md-table-row slot="md-table-row" slot-scope="{ item }" md-auto-select @click="selected(item)">
                <md-table-cell md-label="코드">{{ item.branchId }}</md-table-cell>
                <md-table-cell md-label="대학/지부/분회명">{{ item.branchNm }}</md-table-cell>
              </md-table-row>
            </md-table>
          </div>
-->

          <md-card-content width="800">
            <div align="left">총 {{ total }} 건의 검색결과가 있습니다.</div>
            <grid ref="commcodeGrid"
                  :data="gridProps.data"
                  :columns="gridProps.columns"
                  :options="gridProps.options"
                  :theme="gridProps.theme"
                  :rowHeaders="gridProps.rowHeaders"
                  :columnOptions="gridProps.columnOptions"
                  :language="gridProps.lang"
                  @dblclick="onDblClickExecutive"
                  @response="successResponse"
            ></grid>
          </md-card-content>

        </template>
        <template slot="footer">
          <md-button class="md-default md-sm" @click="closed">닫기</md-button>
        </template>
      </modal>
</template>

<script>

import { Modal } from "@/components";
import { Grid } from '@toast-ui/vue-grid';
import 'tui-grid/dist/tui-grid.css';
import 'tui-pagination/dist/tui-pagination.css';
import URL_CONST from "@/kuaa/kuaa-url-const";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import kuaaFnc from "@/kuaa/kuaa-comm-func";

export default {
  name: "BranchSearchPopComp",
  props: {
    isShow : {
      type: Boolean,
      default: false
    },
    branchGb : {
      type: String
    },
    searchText : {
      type: String
    }
  },
  components: {
    Modal,
    grid: Grid
  },

  created() {
    this.initGrid();
  },

  computed: {
      isModalShow: function(){
          return this.isShow;
      }
  },
  data() {
    return {
      total: 0,
      pagination: {
        perPage: 20,
        page: 1,
        total: 0
      }
    }
  },
  methods: {
    closed(){
        this.$emit('update:isShow', false);
    },

    search() {
      this.$refs.commcodeGrid.invoke("readData", 1, {branchGb: this.branchGb, branchNm: this.searchText});
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(URL_CONST.GET_BRANCH_LIST, false, this.pagination);
      this.gridProps['el'] = this.$refs.commcodeGrid;
      this.gridProps['columns'] = [
          {header: '코드ID', name: 'branchId', width: "100", align:"center", sortable: true},
          {header: '지부/분회명', name: 'branchNm', sortable: true},
        ];
    },

    successResponse(e) {
      if (this.instance == null) {
        this.instance = e.instance;
      }
      let res = JSON.parse(e.xhr.response);
      if(res.result){
        this.total = res.data.pagination.totalCount;
      }else{
        kuaaFnc.gridErrorCallback(e,"브렌치 조회");
      }
    },

    onDblClickExecutive(e) {
      if(e.instance.getRow(e.rowKey) != null) {
        this.$emit('returnResult', e.instance.getRow(e.rowKey));
        this.closed();
      }
    }
  }
}
</script>

<style lang="css" scoped>

</style>